import { axiosInstance } from "./api";


/**
 * Get property for a given project.
 */
export const fetchProperty = async (projectId) => {
  const response = await axiosInstance.get(
    `/runners/getProperty/${projectId}`
  );
  if (response.data) {
    return response.data;
  }
  return null;
};

/**
 * Upload DXF/DWG file of Property.
 */
export const apiUploadProperty = async (projectId, payload) => {
  const response = await axiosInstance.post(
    `/files/dwg/${projectId}`, payload, {headers: {
      "Content-Type": "multipart/form-data",
    },
  }
  );
  if (response.data) {
    return response.data;
  }
  return null;
};

/**
 * Upload units and coordinates.
 */
export const apiUploadPropertyStep2 = async (projectId, payload) => {
  const response = await axiosInstance.post(
    `/files/dwg_step2/${projectId}`, payload,
  );
  if (response.data) {
    return response.data;
  }
  return null;
};
